import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import mineCraftApi from 'src/api/mineCraftApi';
import { UsernameStyleInterface } from 'src/store/mine_craft/usernameStylesSlice';
import { usernameStyleStyles } from "../../helpers/TextHelpers";

const processStrategy = (value: any) => {
  return {
    ...value,
    title: 'Username Style',
    style: (
      usernameStyleStyles({
        text_gradient_angle: value.text_gradient_angle,
        text_color_start: value.text_color_start,
        text_color_end: value.text_color_end,
        stroke_color_end: value.stroke_color_end,
        fontSize: '16px'
      })
    )
  };
}

export const usernameStylesEntity = new schema.Entity(
  'usernameStyles',
  {},
  {
    processStrategy
  }
);

export const usernameStyleEntity = new schema.Entity(
  'usernameStyle',
  {},
  {
    processStrategy
  }
);

const fetchUsernameStylesCollection = async (url: string, params: object = {}) => {
  const response    = await mineCraftApi.get(url, { params })
  const normalized  = normalize<
    any,
    {
      usernameStyles: { [key: string]: UsernameStyleInterface };
    }
  >(response.data.username_styles, [usernameStylesEntity]);

  return {
    usernameStyles: normalized.entities?.usernameStyles || {},
    ids: normalized.result,
    count: response.data.meta?.total_count
  };
}

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<
    any,
    {
      usernameStyle: UsernameStyleInterface;
    }
  >(response.data.username_style, usernameStyleEntity);
  return normalized.entities;
}

export const fetchUsernameStyles = createAsyncThunk(
  'usernameStyles/fetchUsernameStyles',
  async (params: object = {}) => {
    return fetchUsernameStylesCollection('/onesky/username_styles', params);
  }
);

export const fetchUsernameStyle = createAsyncThunk(
  'usernameStyles/fetchUsernameStyle',
  async (id: number | string) => {
    const response = await mineCraftApi.get(`/onesky/username_styles/${id}`);
    return normalizeInstance(response);
  }
);

export const createUsernameStyle = createAsyncThunk(
  'usernameStyles/createUsernameStyle',
  async (data: object, { rejectWithValue }) => {
    try {
      const response = await mineCraftApi.post(`/onesky/username_styles`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const updateUsernameStyle = createAsyncThunk(
  'usernameStyles/updateUsernameStyle',
  async ({ id, data }: { id: number, data: object }, { rejectWithValue }) => {
    try {
      const response = await mineCraftApi.patch(`/onesky/username_styles/${id}`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);

export const destroyUsernameStyle = createAsyncThunk(
  'usernameStyles/destroyUsernameStyle',
  async (id: number) => {
    const response = await mineCraftApi.delete(`/onesky/username_styles/${id}`);
    return response.data;
  }
);

export const reorderUsernameStyles = createAsyncThunk(
  'usernameStyles/reorderUsernameStyles',
  async ({ ids }: { ids: any }, { rejectWithValue }) => {
    try {
      await mineCraftApi.patch('/onesky/username_styles/reorder', { ids })

      return { ids };
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);
